import {
  Card,
  CardBody,
  CardHeader
} from "../../../../../../../_metronic/_partials/controls/index.js"
import { RowModule } from "../../../../../../../component/atoms/RowModule/RowModule.jsx"
import React, { useEffect, useState } from "react"
import { SelectInput, TextInput } from "../../../../../../../component/index.jsx"
import { useDispatch, useSelector } from "react-redux"
import { getListRoleByParam } from "../../../../../../../redux/actions/RoleAction.jsx"
import { useFormikContext } from "formik"
import { fetchProvince } from "../../../../../../../redux/actions/MasterDataAction.jsx"
import { useTranslation } from "react-i18next"

export const CreateUser = ({ isReadOnly, setIsValid }) => {
  const { MasterData } = useSelector((state) => state)
  const dispatch = useDispatch()
  const { values: formValues } = useFormikContext()
  const { t } = useTranslation()
  const [stateRole, setStateRole] = useState()
  const { Role } = useSelector((state) => state)
  const [role, setRole] = useState(formValues["role"])
  let [proviceList, setProvinceList] = useState([])
  const [province, setProvince] = useState(formValues["province"])
  const { values } = useFormikContext()

  useEffect(() => {
    if (values?.name && values?.email && values?.role && values?.phone && values?.province_id) {
      setIsValid(false)
    } else {
      setIsValid(true)
    }
  }, [values])

  useEffect(() => {
    dispatch(getListRoleByParam("non_fo"))
  }, [])

  useEffect(() => {
    dispatch(fetchProvince())
  }, [])

  useEffect(() => {
    setProvinceList(
      MasterData.listRegionalSelected.map((value) => ({ label: value.name, value: value.id }))
    )
  }, [MasterData])

  useEffect(() => {
    const allString = { label: "All", value: "ALL" }
    proviceList.unshift(allString)
  }, [proviceList])

  useEffect(() => {
    if (Role.listRole) {
      setStateRole(Role.listRole.map((value) => ({ label: value.display_name, value: value.id })))
    }
  }, [Role.listRole])

  useEffect(() => {
    if (formValues.hasOwnProperty("role")) {
      setRole(formValues["role"])
    }
  }, [formValues["role"]])

  useEffect(() => {
    if (formValues.hasOwnProperty("province_id")) {
      setProvince(formValues["province_id"])
    }
  }, [formValues["province_id"]])

  const onChangeRole = (e) => {
    setRole(e)
  }
  const onChangeProvince = (e) => {
    setProvince(e)
  }

  return (
    <>
      <Card className="card-custom card-shadowless">
        <CardHeader title={t("label_user_information").toUpperCase()} />
        <CardBody>
          <RowModule>
            <TextInput
              editable={!isReadOnly}
              label={t("label_user_full_name")}
              name="name"
              placeholder={t("placeholder_input_user_full_name")}
              type={"text"}
            />
          </RowModule>

          <RowModule>
            <TextInput
              editable={!isReadOnly}
              label="Email"
              name="email"
              placeholder="Contoh : user@maxxitani.id"
              type={"email"}
            />
          </RowModule>
          <RowModule>
            <SelectInput
              name="role"
              onChange={onChangeRole}
              editable={!isReadOnly}
              label="Role User"
              placeholder={t("placeholder_choose_role_user")}
              options={stateRole}
              withoutFeedback={false}
              clearNow={true}
              value={role}
            />
          </RowModule>
          <RowModule>
            <SelectInput
              name={"province_id"}
              onChange={onChangeProvince}
              editable={!isReadOnly}
              label="Regional"
              placeholder={t("placeholder_choose_one")}
              options={proviceList}
              withoutFeedback={false}
              clearNow={true}
              value={province}
            />
          </RowModule>

          <RowModule>
            <TextInput
              editable={!isReadOnly}
              label={t("label_phone_number")}
              name="phone"
              placeholder={t("placeholder_input_no_hp")}
              type={"text"}
            />
          </RowModule>
        </CardBody>
      </Card>
    </>
  )
}
